// Editorial page header for internal pages — matches the homepage hero style:
// gold eyebrow + large uppercase title + optional subtitle.
export default function PageHeader({ eyebrow, title, subtitle, divider = true }) {
  return (
    <header className="pt-2 sm:pt-4">
      {eyebrow && (
        <p className="on-photo text-kj-gold text-xs sm:text-sm font-extrabold tracking-[0.28em] uppercase mb-3 sm:mb-4">
          {eyebrow}
        </p>
      )}
      <h1 className="on-photo text-3xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[0.98] tracking-tight text-kj-ink text-balance">
        {title}
      </h1>
      {subtitle && (
        <p className="on-photo mt-4 sm:mt-5 text-base sm:text-lg text-kj-sub max-w-[54ch] leading-relaxed">
          {subtitle}
        </p>
      )}
      {divider && <div className="mt-6 sm:mt-8 h-px w-full bg-white/15" />}
    </header>
  );
}
